
import axiosInstance from "../Utils/axiosInterceptor";
import {OrderItem} from "../models/OrderItem";


export class PaymentService {

    static async retrieveOzowPaymentLink(orderItems:OrderItem[]) {
        try {
            const response = await axiosInstance.get("/retrieve_ozow_payment_link/");
            return response.data;
        } catch (error) {
            console.error('Failed to fetch restaurants:', error);
            throw error;
        }
    }


    static async retrievePaymentPaymentLink(driverFee: number) {
        try {
            const response = await axiosInstance.get("/retrieve_pay_stack_payment_link/"+driverFee);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch restaurants:', error);
            throw error;
        }
    }

    static async checkPaymentStatus(order_ref: any) {
        try {
            const response = await axiosInstance.get("/check_payment_status/"+order_ref);
            return response.data;
        } catch (error) {
            console.error('Failed to fetch restaurants:', error);
            throw error;
        }
    }
}
